import { render, staticRenderFns } from "./OTPForm.vue?vue&type=template&id=31778ee2"
import script from "./OTPForm.vue?vue&type=script&lang=js"
export * from "./OTPForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports